<template>
    <div class="dashboard_container" style="min-width: 1310px;">
        <div class="tfa-dashboard-section cn-dashboard-section">
            <div class="top-section row">
                <div class="dashboard-row stream-section col-12" style="max-width: 100%;">
                    <div>
                        <div class="card" style="min-height: 475px !important; min-width: 846px;">
                            <div class="card-body text-center mt-5">
                                <h4>{{subscriptionMessage}}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import '../../../assets/module/css/dashboard/tfaDashboard.min.css'
    import { mapActions } from 'vuex'

    export default {
      name: 'clearly-next-student-subscription-success',
      data: () => {
        return {
          subscriptionMessage: ''
        }
      },

      mounted () {
        this.navigateToUserSubscriptionPage()
      },
    
      methods: {
        ...mapActions([
          'loadStripeSubscriptionCreation'
        ]),
        navigateToUserSubscriptionPage () {
          let userId = this.$route.query.u_id
          let planType = this.$route.query.plan_type
          let checkoutSessionId = this.$route.query.session_id
          this.populateSubscriptionMessage(planType)
          this.loadStripeSubscriptionCreation({planType: planType, sessionId: checkoutSessionId}).then(res => {
            if (res) {
              setTimeout(() => {
                return this.$router.push({name: 'clearlyNextStudentSubscription', params: {uuid: userId, checkoutSessionId: checkoutSessionId}})
              }, 5000)
            } else {
              return this.$router.push({name: 'clearlyNextStudentSubscriptionFailure', params: {uuid: userId}})
            }
          })
        },
        populateSubscriptionMessage (planType) {
          let message = 'Your plan "PLAN_NAME_PLACEHOLDER" successfully activated. You will be redirected on subscription page in few seconds.'
          switch (planType) {
            case 'gold':
              this.subscriptionMessage = message.replace('PLAN_NAME_PLACEHOLDER', 'Gold Tier')
              break
            case 'platinum':
              this.subscriptionMessage = message.replace('PLAN_NAME_PLACEHOLDER', 'Platinum Tier')
              break
            default:
              this.subscriptionMessage = message.replace('PLAN_NAME_PLACEHOLDER', 'Premium Tier')
          }
        }
      }
    }
</script>


// WEBPACK FOOTER //
// src/app/user/components/ClearlyNextStudentSubscriptionSuccess.vue